// extracted by mini-css-extract-plugin
export default {"ball":"style_ball__PfSzL"};